<template>
  <div>
    <CheckboxGroup v-model="selectValue" @on-change="getSelect">
      <Checkbox :label="ele.code" :key="ele.code" v-for="(ele, index) in dicList">{{ ele.name }}</Checkbox>
    </CheckboxGroup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    dicName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectValue: [],
      appCode: 'bsp',
      dicList: []
    }
  },
  watch: {
    dicName: {
      handler(n, o) {
        n ? this.getData() : ''
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(n, o) {
        if (n) {
          this.$set(this, 'selectValue', n.split(','))
        } else {
          this.$set(this, 'selectValue', [])
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getData() {
      this.$store
        .dispatch('authGetRequest', {
          url: `/bsp-com/static/dic/${this.appCode}/${this.dicName}.js`
        })
        .then(res => {
          let arr = []
          let numTon = eval('(' + res + ')')
          arr = numTon()
          this.dicList = arr
        })
    },
    getSelect(data) {
      this.$emit('input', this.selectValue.join(','))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/component/data-grid/components/data-checkbox.vue